module.exports = __webpack_public_path__ + "img/plus.df3bdf7e.svg";